import { Component, OnInit } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { Cliente } from 'src/app/core/models/cliente.model';
import { Loja } from 'src/app/core/models/loja.model';
import { Produto } from 'src/app/core/models/produto.model';
import { WeblabService } from 'src/app/core/services/weblab.service';
import { NovoPedidoOlho } from './components/novo-pedido-olho/novo-pedido-olho.component';
import { NovoPedidoProdutoRequest, NovoPedidoReceitaRequest, NovoPedidoRequest, NovoValorRequest } from 'src/app/core/models/request/novo-pedido.request.model';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NovoPedidoArmacao } from 'src/app/core/models/novo-pedido-armacao.model';
import { ClienteResponse } from 'src/app/core/models/response/cliente-response.model';
import { LojaResponse } from 'src/app/core/models/response/loja-response.model';
import { ConfirmationService } from 'primeng/api';
import * as moment from 'moment';
import {jsPDF} from 'jspdf';
import { Router } from '@angular/router';

@Component({
  selector: 'app-novo-pedido',
  templateUrl: './novo-pedido.component.html',
  styleUrls: ['./novo-pedido.component.scss']
})

export class NovoPedidoComponent implements OnInit {
  novoPedido: NovoPedidoRequest;
  busyCombos: boolean = false;
  busyComboProduto: boolean = false;
  carregadoComboProduto: boolean = false;
  produtosAdicionados: Produto[] = [];
  confirmBtnNaoVisible: boolean = false;
  modalCadastrarPedido: boolean = false;
  pedidoCadastrado?: number;
  textoCadastrarNovoPedido: string;
  id?: string;
  pedido_lab?: string;

  opcaoPedidoSelecionado: string = 'pedido_lab';
  tituloPedidoSelecionado: string = 'Pedido Laboratório';

  private lblSalvandoPedido = 'Estamos salvando seu pedido ...';
  private lblPedidoSalvo = 'Pedido cadastrado com sucesso';
  private lblPedidoAlterado = 'Pedido alterado com sucesso';
  private lblErroSalvarPedido = 'Não foi possível enviar seu pedido';
  lblModalSalvarPedido = this.lblSalvandoPedido;

  public listagemTipoMontagem = [
    {id: 1, tipo:'ARO FECHADO'},
    {id: 2, tipo:'MEIO ARO (FIO DE NYLON)'},
    {id: 3, tipo:'TRÊS PEÇAS (BALGRIFF)'},
    {id: 4, tipo:'ESPORTIVAS (CURVADAS)'}
  ];

  date: Date;

  // Forms
  dadosForm: any = {
    numeroOS: null,
    paciente: '',
    opcaoOlhoSelecionado: 'ambos',
    olhoDireito: {} as NovoPedidoOlho,
    olhoEsquerdo: {} as NovoPedidoOlho,
    armacao: {} as NovoPedidoArmacao,
    servicosAdicionados: [] as Produto[],
    observacao: ''
  };

  pedidoAprovado: boolean = false;
  loadingSave: boolean = false;
  pdfLiberado: boolean = false;

  constructor(
    private service: WeblabService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.route.url.subscribe((event) => {
      if (event[0].path === 'pedido-atacado') {
        this.opcaoPedidoSelecionado = 'pedido_atacado';
        this.tituloPedidoSelecionado = 'Pedido Atacado'
      }
    });

    this.id = (this.route.snapshot.paramMap.get('id') || "").toString().trim() || undefined;
    this.pedido_lab = (this.route.snapshot.paramMap.get('pedido_lab') || "").toString().trim() || undefined;

    await this.carregarLojasClientes();
    if (this.id && this.pedido_lab) {
      await this.loadData(this.pedido_lab);
    }
    await this.carregaCombos(true);

    this.date = new Date(moment().subtract(0, 'days').format());
  }

  lojas: Array<Loja>;
  laboratorioSelecionado: Loja | undefined;

  clientes: Array<Cliente>;
  lojaSelecionada: Cliente | undefined;

  async carregarLojasClientes() {
    this.busyCombos = true;
    const dadosLojas = await new Promise((resolve, reject) => this.service.buscarLojas().subscribe({ next: resolve, error: reject }));
    const dadosClientes = await new Promise((resolve, reject) => this.service.buscarClientes().subscribe({ next: resolve, error: reject }));

    let lojas = (dadosLojas as LojaResponse)?.lojas;
    let clientes = (dadosClientes as ClienteResponse)?.Clientes;

    this.clientes = clientes?.sort((a, b) => {
      const nameA = a.nome.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      const nameB = b.nome.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

    this.lojas = lojas?.sort((a, b) => {
      const nameA = a.razao_social.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      const nameB = b.razao_social.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      
      if (nameA < nameB) {
        return -1;
      }

      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

    this.service.clientes = this.clientes;
    this.service.lojas = this.lojas;
  }

  async carregaCombos(init = false) {
    if (this.service.lojas?.length > 0 && this.service.clientes?.length > 0) {
      console.log('combos ja carregados');

      this.lojas = this.service.lojas;
      this.clientes = this.service.clientes;
      
      await this.campoPreenchido(init);
      this.busyCombos = false;
      return;
    }
    
    await this.campoPreenchido(init);
    this.busyCombos = false;
  }

  async campoPreenchido(init = false) {
    if (!this.id) {
      if(this.lojas.length == 1) {
        this.laboratorioSelecionado = this.lojas[0];
      }
  
      if(this.clientes.length == 1) {
        this.lojaSelecionada = this.clientes[0];
      }
    }

    await this.carregarComboProdutos(init);
  }

  async changeLoja() {
    await this.carregarComboProdutos();
  }

  async changeLaboratorio() {
    await this.carregarComboProdutos();
  }

  get codLoja(): number | undefined {
    return this.laboratorioSelecionado?.codigo;
  }

  get codCliente(): number | undefined {
    return this.lojaSelecionada?.cod_cliente;
  }

  async carregarComboProdutos(init = false) {
    if (!this.codLoja || !this.codCliente) return;

    if (!init) {
      this.produtosAdicionados = [];
    }

    this.busyComboProduto = true;
    this.carregadoComboProduto = true;
    this.busyComboProduto = false;
  }

  handleRequest() {
    return function (observable: Observable<any>) {
      return observable.pipe(
        map((result) => {
          return result;
        }),
        catchError((err) => {
          return of(null);
        })
      );
    };
  }

  totalQuantidade() {
    return this.produtosAdicionados
      .map(item => item.quantidadeAdd)
      .reduce((prev, curr) => prev + curr, 0);
  }

  valorTotal() {
    return this.produtosAdicionados
      .map(item => item.vlr_liquido_produto * item.quantidadeAdd)
      .reduce((prev, curr) => prev + curr, 0);
  }

  descontoTotal() {
    return this.produtosAdicionados
      .map(item => (item.vlr_venda_tratado - item.vlr_liquido_produto) * item.quantidadeAdd)
      .reduce((prev, curr) => prev + curr, 0);
  }

  confirmCadastrarPedido() {
    this.confirmBtnNaoVisible = true;

    this.confirmationService.confirm({
      header: this.id ? 'Alterar pedido' : 'Cadastrar novo pedido',
      message: this.id ? 'Realmente deseja alterar este pedido?' : 'Realmente deseja cadastrar este novo pedido?',
      // icon: 'pi pi-question',
      accept: () => {
        this.salvarPedido();
      },
      reject: () => {
        this.confirmBtnNaoVisible = false;
      }
    });
  }

  calcularValor(valor: number, quant: number, porcentagem: number): number {
    const multiplicacao = valor * quant;
    const desconto = (porcentagem / 100) * multiplicacao;
    return multiplicacao - desconto;
  }

  salvarPedido() {
    this.lblModalSalvarPedido = this.lblSalvandoPedido;
    this.loadingSave = true;
    this.modalCadastrarPedido = true;

    try {

      let olhoDireito = this.dadosForm.olhoDireito;
      let olhoEsquerdo = this.dadosForm.olhoEsquerdo;
      let armacao = this.dadosForm.armacao;
      let carrinho: Array<NovoPedidoProdutoRequest> = [];
      let valorL: Array<NovoValorRequest> = [];
      
      this.produtosAdicionados.forEach(servico => {
        carrinho.push({
          cod_produto: servico.cod_produto,
          valor: servico.vlr_venda_tratado,
          quantidade: servico.quantidadeAdd,
          uso_olho: servico.tipo_prod,
          desc_acresc_porcentagem: servico.desc_acresc_porcentagem,
          subtotal_prod: this.calcularValor(servico.vlr_venda_tratado, servico.quantidadeAdd, servico.desc_acresc_porcentagem),
        })
      });
      
      this.produtosAdicionados.forEach(servico => {
        valorL.push({
          valorLiquidoTotal: servico.vlr_liquido_produto * servico.quantidadeAdd
        })
      })
      const totalBruto = carrinho
        .map(item => item.subtotal_prod)
        .reduce((prev, curr) => prev + curr, 0);

      const totalLiquido = valorL
        .map(item => item.valorLiquidoTotal)
        .reduce((prev, curr) => prev + curr, 0);

      this.novoPedido = {
        cnpj: this.laboratorioSelecionado?.cnpj ?? '',
        cod_cliente: this.lojaSelecionada?.cod_cliente,
        nro_os_loja: this.dadosForm.numeroOS,
        cod_venda_app: this.id ? `${this.id}-2` : '',
        cod_vendedor: 0,
        cod_medico: 0,
        FormasDePagamentos: [],
        Carrinho: carrinho,
        Receita: this.retornaReceita(olhoDireito, olhoEsquerdo, armacao),
        valor_total_bruto: totalBruto,
        valor_total_liquido: totalLiquido
      }

      this.service.cadastrarPedido(this.novoPedido).subscribe({
        next: (resp) => {
          this.pedidoCadastrado = resp.mov_tipo_nro;
          this.textoCadastrarNovoPedido = `Pedido lab: `;
          this.lblModalSalvarPedido = this.id ? this.lblPedidoAlterado : this.lblPedidoSalvo;
          this.pdfLiberado = true;
          if (this.modalCadastrarPedido === false)
            this.limpar();
        },
        error: (error) => {
          this.loadingSave = false;
          this.confirmBtnNaoVisible = false;
          this.pdfLiberado = false;

          let msgError = '';
          let errors = error.error?.errors;
          if (errors?.length > 0) {
            msgError = errors[0];
          }

          this.textoCadastrarNovoPedido = `Erro ao cadastrar pedido: ${msgError}`;
        },
        complete: () => {
          this.loadingSave = false;
        }
      })
    } catch (e) {
      this.pdfLiberado = false;
      this.loadingSave = false;
      this.lblModalSalvarPedido = this.lblErroSalvarPedido;
      this.textoCadastrarNovoPedido = `Por favor, preencha todos os campos e tente reenviar`;
      console.error(e);
    }
  }

  private retornaReceita(olhoDireito: NovoPedidoOlho, olhoEsquerdo: NovoPedidoOlho, armacao: any): NovoPedidoReceitaRequest {
    if (this.opcaoPedidoSelecionado !== 'pedido_lab') return {};

    const dataReceita = this.dadosForm.DtReceita?.toISOString().replaceAll('-', '_');

    return {
      tipo_lente: "LT - Lente",
      data_receita: dataReceita,
      longe_esferico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeEsferico),
      longe_esferico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeEsferico),
      longe_cilindrico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeCilindrico),
      longe_cilindrico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeCilindrico),
      longe_eixo_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeEixo),
      longe_eixo_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeEixo),
      longe_dnp_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeDNP),
      longe_dnp_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeDNP),
      adicao_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoAdicao),
      adicao_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoAdicao),
      perto_esferico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoEsferico),
      perto_esferico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoEsferico),
      perto_cilindrico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoCilindrico),
      perto_cilindrico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoCilindrico),
      perto_eixo_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoEixo),
      perto_eixo_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoEixo),
      perto_dnp_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoDNP),
      perto_dnp_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoDNP),
      altura_pupila_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoAlturaPupila),
      altura_pupila_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoAlturaPupila),
      prisma_valor_horizontal_od: this.formatDecimalToStringApi(olhoDireito?.olhoPrismaHorizontalValor),
      prisma_base_horizontal_od: olhoDireito?.olhoPrismaHorizontalBase?.nome ?? '',
      prisma_valor_vertical_od: this.formatDecimalToStringApi(olhoDireito?.olhoPrismaVerticalValor),
      prisma_base_vertical_od: olhoDireito?.olhoPrismaVerticalBase?.nome ?? '',
      prisma_valor_horizontal_oe: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPrismaHorizontalValor),
      prisma_base_horizontal_oe: olhoEsquerdo?.olhoPrismaHorizontalBase?.nome ?? '',
      prisma_valor_vertical_oe: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPrismaVerticalValor),
      prisma_base_vertical_oe: olhoEsquerdo?.olhoPrismaVerticalBase?.nome ?? '',
      distancia_pupilar: this.formatDecimalToStringApi(armacao.armacaoDistPupilar),
      ponte: this.formatDecimalToStringApi(armacao.armacaoPonte),
      aro: this.formatDecimalToStringApi(armacao.armacaoAro),
      diagonal_maior: this.formatDecimalToStringApi(armacao.armacaoDiagMaior),
      diametro_apurado: this.formatDecimalToStringApi(armacao.armacaoDiamApurado),
      mov_alt_vertical: this.formatDecimalToStringApi(armacao.armacaoAltVertical),
      instrucoes_especiais: '',
      previsao_entrega: '',
      observacao: this.dadosForm.observacao,
      datanasc_paciente: '',
      parentesco_paciente: '',
      paciente: this.dadosForm.paciente,
      tipo_montagem: armacao.tipoMontagem?.id,
    };
  }

  private async limpar() {
    this.confirmBtnNaoVisible = false;
    this.busyCombos = false;
    this.busyComboProduto = false;
    this.carregadoComboProduto = false;
    this.loadingSave = false;
    this.lojaSelecionada = undefined;
    this.laboratorioSelecionado = undefined;
    this.produtosAdicionados = [];
    this.dadosForm = {
      numeroOS: null,
      paciente: '',
      opcaoOlhoSelecionado: 'ambos',
      olhoDireito: {} as NovoPedidoOlho,
      olhoEsquerdo: {} as NovoPedidoOlho,
      armacao: {} as NovoPedidoArmacao,
      servicosAdicionados: [] as Produto[]
    };

    await this.campoPreenchido();
  }

  deletarServico(prouduto: any, index: any) {
    this.produtosAdicionados.splice(index, 1);
  }

  async fecharModalRespostaCadastrarPedido() {
    if (this.pedidoCadastrado) {
      if (!this.id) {
        this.limpar();
      }
      else {
        this.router.navigate(["/oticomlab/pedidos"]);
        return;
      }
    }
    this.campoPreenchido();

  }

  pedidoValido() {
    return !this.loadingSave &&
      ((this.opcaoPedidoSelecionado === 'pedido_lab') ||
        (this.opcaoPedidoSelecionado !== 'pedido_lab')) &&
      this.lojaSelecionada &&
      this.laboratorioSelecionado &&
      this.produtosAdicionados.length > 0;
  }

  formatDecimalToStringApi(value?: number): string {
    // return value.toString().replace('.', ',');
    if (!value) return '';

    return value.toLocaleString('pt-BR', { useGrouping: false })
  }

  solicitarPDF(opcaoPedidoSelecionado: string) {
    this.service.buscarClienteCod(this.novoPedido.cod_cliente).subscribe({
      next: (cliente: ClienteResponse) => {
        const clienteSelecionado = cliente.Clientes.filter(x => x.cod_cliente === this.novoPedido.cod_cliente);  
        this.imprimirPdf(opcaoPedidoSelecionado, clienteSelecionado[0]);            
      },
    });
  }

  // imprimirPdf(opcaoPedidoSelecionado: string, cliente: any) {

  //   let logo = this.logoLaboratorio();

  //   const margins = { top: 30, bottom: 30, left: 10, right: 10 };

  //   const doc = new jsPDF();
  //   doc.setFont('Helvetica');
  //   doc.setFontSize(18);
  //   doc.addImage(logo, 160, 10, 40, 20);
  //   doc.text('Pedido OticomLab', 10, 20);

  //   if(opcaoPedidoSelecionado === 'pedido_lab') {

  //     doc.setFontSize(12);
  //     doc.text(`Laboratório: ${this.laboratorioSelecionado?.razao_social}`, 10, 40);
  //     doc.text(`Pedido: ${this.pedidoCadastrado}`, 165, 40);
  //     doc.text(`Ótica: ${this.lojaSelecionada?.nome}`, 10, 50);
  //     doc.text(`OS: ${this.novoPedido?.nro_os_loja}`, 10, 60);
  //     doc.text(`Paciente: ${this.novoPedido?.Receita?.paciente}`, 40, 60);

  //     let dataFormatada = this.formatDate(this.novoPedido?.Receita?.data_receita);
  //     doc.text(`Data: ${dataFormatada}`, 165, 60);
  //   }
    
  //   if(opcaoPedidoSelecionado === 'pedido_atacado') {

  //     doc.setFontSize(12);
  //     doc.text(`Laboratório: ${this.laboratorioSelecionado?.razao_social}`, 10, 40);
  //     doc.text(`Pedido: ${this.pedidoCadastrado}`, 165, 40);
  //     doc.text(`Ótica: ${this.lojaSelecionada?.nome}`, 10, 50);
  //     doc.text(`Data: ${this.novoPedido?.Receita?.data_receita}`, 165, 60);    
  //   }

  //   doc.text(`Itens`, 10, 80);
  //   doc.text(`Produtos`, 10, 90);
  //   doc.text(`Qtde`, 118, 90);
  //   doc.text(`Valor`, 135, 90);
  //   doc.text(`Desconto`, 158, 90);
  //   doc.text(`Subtotal`, 180, 90);

  //   for (let i = 0; i < this.produtosAdicionados.length; i++) {
  //     let item = i * 10;
  //     let linha = 100 + item;
      
  //     doc.text(`${this.produtosAdicionados[i].descricao}`, 10, linha, {maxWidth: 100});
  //     doc.text(`${this.produtosAdicionados[i].quantidadeAdd}`, 120, linha + 2);

  //     let formattedValue = this.produtosAdicionados[i].vlr_venda_tratado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //     doc.text(`R$ ${formattedValue}`, 135, linha + 2);

  //     doc.text(`${this.produtosAdicionados[i].desc_acresc_porcentagem ?? 0 }%`, 165, linha + 2);

  //     let sub = this.produtosAdicionados[i].vlr_liquido_produto * this.produtosAdicionados[i].quantidadeAdd
  //     let subformattedValue = sub.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //     doc.text(`R$ ${subformattedValue}`, 180, linha + 2);    
  //   }

  //   let item = (this.produtosAdicionados.length * 10) + 105;

  //   doc.text(`Qtde de itens ${this.produtosAdicionados.length}`, 135, item);
  //   doc.text(`Desconto total ${this.descontoTotal()}`, 135, item + 10);
    
  //   let formattedValorT = this.valorTotal().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //   doc.text(`Valor total R$ ${formattedValorT}`, 135, item + 20);

  //   doc.text(`Observações`, 10, item + 40);
  //   doc.text(`${this.novoPedido.Receita?.observacao}`, 10, item + 50); 

  //   doc.save('pedido_otc_lab.pdf');
  // }

  imprimirPdf(opcaoPedidoSelecionado: string, cliente: any) {
    const doc =  new jsPDF();
    // 1° quadro
    doc.roundedRect(10, 10, 190, 30, 2, 2); // 1° retangulo
    let logo = this.logoLaboratorio();
    doc.addImage(logo,'JPEG', 12.5, 12.5, 35, 25); // imagem (imageData, formato, x, y, width, height)

    const cam1linha1: number = 17;
    const cam1linha2: number = 26;
    const cam1linha3: number = 36;
    const cam2linha1: number = 52;
    const cam2linha2: number = 57;
    const cam2linha3: number = 62;
    const cam3linha1: number = 78;
    const cam3linha2: number = 84;
    const camInt1titulo: number = 91;
    const camInt1linha1: number = 98;
    const camInt1linha2: number = 104;
    const camInt1linha3: number = 110;
    const camInt2titulo: number = 118;
    const camInt2linha1: number = 125;
    const camInt2linha2: number = 130;
    const tituloSpec: number = 175;
    const tituloSpec2: number = 75;
    const desc1Spec: number = 182;
    const desc1Spec2: number = 82;
    const desc2Spec: number = 189;
    const desc3Spec: number = 196;
    const desc4Spec: number = 203;
    // 1° linha
    doc.setFont('Helvetica');
    doc.setFontSize(8);    
    doc.text(`${this.laboratorioSelecionado?.nome_fantasia}`, 50, cam1linha1);
    doc.setFont('Helvetica','','bold');
    doc.setFontSize(8);
    doc.text('Pedido Lab:', 142, cam1linha1);
    doc.setTextColor(135,17,17);
    const nPedido = this.pedidoCadastrado ?? "-";
    doc.text(nPedido.toString(), 160, cam1linha1, {maxWidth:40});
    // doc.text(this.novoPedido?.nro_os_loja, 160, cam1linha1, {maxWidth:40});

    // 2° linha
    doc.setFontSize(8);
    doc.setTextColor(0,0,0);
    
    doc.setFont('Helvetica','','bold');
    doc.text('Data do período:', 50, cam1linha2);
    doc.setFont('Helvetica','','normal');
    let dataFormatada = this.formatDate(this.date.toString());

    doc.text(dataFormatada ? dataFormatada : '-', 75, cam1linha2);
    // doc.text('-', 75, cam1linha2);
    doc.setFont('Helvetica','','bold');
    doc.text('Previsão entrega:', 142, cam1linha2);
    doc.setFont('Helvetica','','normal');
    doc.text(this.novoPedido?.Receita?.previsao_entrega ? this.novoPedido?.Receita?.previsao_entrega : '-', 168, cam1linha2);

    // 3° linha
    doc.setFont('Helvetica','','bold');
    doc.setTextColor(255,9,9);
    doc.text(`VENDA - 01 DIGITAÇÃO`, 50, cam1linha3);
    // doc.text(`VENDA -`, 50, cam1linha3);
    doc.setTextColor(0,0,0);
    doc.text('Entrega efetiva:', 142, cam1linha3);
    doc.setFont('Helvetica','','normal');
    doc.text(this.novoPedido?.Receita?.previsao_entrega ? this.novoPedido?.Receita?.previsao_entrega : '-', 168, cam1linha3);

    // 2° quadro
    doc.roundedRect(10, 45, 190, 20, 2, 2); // 2° retangulo
    doc.setFillColor(255,255,255); // cor retangulo branco
    doc.rect(15, 42.5, 30, 5,'F'); // retangulo branco
    doc.setFont('Helvetica','','bold');
    doc.setTextColor(135,17,17);
    doc.text('Dados da Loja', 18, 46);
    // 1° linha
    doc.setTextColor(0,0,0);
    doc.text('Cliente', 15, cam2linha1);
    doc.setFont('Helvetica','','normal');
    // doc.text(this.novoPedido?.Receita?.paciente ? this.novoPedido?.Receita?.paciente : '-', 30, cam2linha1);
    doc.setFont('Helvetica','','bold');
    doc.text('Telefone', 128, cam2linha1);
    doc.text('Celular', 155, cam2linha1);
    doc.text('OS', 187, cam2linha1);
    // 2° linha
    doc.setFont('Helvetica','','normal');
    // doc.text(cliente.cod_cliente ? cliente.cod_cliente.toString() : '-', 18, cam2linha2);
    doc.text(cliente.nome_fantasia_social ? cliente.nome_fantasia_social : '-', 18, cam2linha2);
    doc.text(cliente.telefone ? cliente.telefone : '-', 128, cam2linha2);
    doc.text(cliente.celular ? cliente.celular : '-', 155, cam2linha2);
    doc.setFont('Helvetica','','bold');
    doc.text('Cliente', 185, cam2linha2);
    // 3° linha
    doc.text('Endereço:', 15, cam2linha3);
    doc.setFont('Helvetica','','normal');
    const endereco = cliente.endereco ? cliente.endereco : '-';
    const numero = cliente.numero ? cliente.numero : '-';
    const complemento = cliente.complemento ? cliente.complemento : '-';
    const bairro = cliente.bairro ? cliente.bairro : '-';
    const cidade = cliente.cidade ? cliente.cidade : '-';
    const estado = cliente.estado ? cliente.estado : '-';
    const enderecoCompleto = `${endereco}, ${numero}, ${complemento}, ${bairro}, ${cidade} / ${estado}`;
    doc.text(`${enderecoCompleto}`, 30, cam2linha3);
    doc.text(this.novoPedido?.nro_os_loja ? this.novoPedido?.nro_os_loja : '-', 185, cam2linha3);

    if(opcaoPedidoSelecionado === 'pedido_lab') {
      // 3° quadro
      doc.roundedRect(10, 70, 190, 71, 2, 2); // 3° retangulo
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(15, 67.5, 30, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(135,17,17);
      doc.text('Dados da receita', 18, 71);
      // 1° linha
      doc.setTextColor(0,0,0);
      doc.setFont('Helvetica','','bold');
      doc.text('Paciente:', 15, cam3linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.paciente ? this.novoPedido?.Receita?.paciente : '-', 30, cam3linha1);
      // 2° linha
      doc.setFont('Helvetica','','bold');
      doc.text('Data da receita:', 157, cam3linha2);
      doc.setFont('Helvetica','','normal');
      let dataFormatadaReceita = this.formatDate(this.novoPedido?.Receita?.data_receita);
      doc.text(dataFormatadaReceita ? dataFormatadaReceita : '-', 180, cam3linha2);
      // 1° quadro interno
      doc.roundedRect(15, 90, 180, 22, 2, 2); // retangulo interno
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(20, 88, 10, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(25,9,175);
      doc.text('Longe', 21, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(57, 88, 9, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Perto', 58, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(92, 88, 19, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Dist. Pupilar', 93, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(115, 88, 16, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Alt. Pupila', 116, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(135, 88, 26, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Prisma horizontal', 136, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(165, 88, 25, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Prisma vertical', 168, camInt1titulo);
      // 1° linha
      doc.setTextColor(0,0,0);
      doc.setFontSize(6); 
      doc.text('Esf.', 28, camInt1linha1);
      doc.text('Cil.', 36, camInt1linha1);
      doc.text('Eixo', 42, camInt1linha1);
      doc.text('DNP', 49, camInt1linha1);
      doc.text('Adição', 56, camInt1linha1);
      doc.text('Esf.', 64, camInt1linha1);
      doc.text('Cil.', 71, camInt1linha1);
      doc.text('Eixo', 78, camInt1linha1);
      doc.text('DNP', 84, camInt1linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.distancia_pupilar ? this.novoPedido?.Receita?.distancia_pupilar.toString() : '-', 100, camInt1linha1);
      doc.setFont('Helvetica','','bold');
      doc.text('Valor', 138, camInt1linha1);
      doc.text('Base', 150, camInt1linha1);
      doc.text('Valor', 168, camInt1linha1);
      doc.text('Base', 180, camInt1linha1);

      doc.line(25,100,190,100);
      doc.line(25,106,190,106);
      // doc.line(25,94,25,112);
      doc.line(54.5,94,54.5,112);
      doc.line(90,94,90,112);
      doc.line(113,94,113,112);
      doc.line(133,94,133,112);
      doc.line(163,94,163,112);
      // 2° linha
      doc.setFontSize(8); 
      doc.text('OD', 20, camInt1linha2);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(this.novoPedido?.Receita?.longe_esferico_olho_direito ? this.novoPedido?.Receita?.longe_esferico_olho_direito.toString() : '-', 28, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.longe_cilindrico_olho_direito ? this.novoPedido?.Receita?.longe_cilindrico_olho_direito.toString() : '-', 35, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.longe_eixo_olho_direito ? this.novoPedido?.Receita?.longe_eixo_olho_direito.toString() : '-', 42, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.longe_dnp_olho_direito ? this.novoPedido?.Receita?.longe_dnp_olho_direito.toString() : '-', 49, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.adicao_olho_direito ? this.novoPedido?.Receita?.adicao_olho_direito.toString() : '-', 56, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_esferico_olho_direito ? this.novoPedido?.Receita?.perto_esferico_olho_direito.toString() : '-', 64, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_cilindrico_olho_direito ? this.novoPedido?.Receita?.perto_cilindrico_olho_direito.toString() : '-', 71, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_eixo_olho_direito ? this.novoPedido?.Receita?.perto_eixo_olho_direito.toString() : '-', 78, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_dnp_olho_direito ? this.novoPedido?.Receita?.perto_dnp_olho_direito.toString() : '-', 84, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.altura_pupila_olho_direito ? this.novoPedido?.Receita?.altura_pupila_olho_direito.toString() : '-', 122.5, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_valor_horizontal_od ? this.novoPedido?.Receita?.prisma_valor_horizontal_od.toString() : '-', 140, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_base_horizontal_od ? this.novoPedido?.Receita?.prisma_base_horizontal_od.toString() : '-', 150, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_valor_vertical_od ? this.novoPedido?.Receita?.prisma_valor_vertical_od.toString() : '-', 170, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_base_vertical_od ? this.novoPedido?.Receita?.prisma_base_vertical_od.toString() : '-', 180, camInt1linha2);
      // 3° linha
      doc.setFont('Helvetica','','bold');
      doc.setFontSize(8); 
      doc.text('OE', 20, camInt1linha3);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(this.novoPedido?.Receita?.longe_esferico_olho_esquerdo ? this.novoPedido?.Receita?.longe_esferico_olho_esquerdo.toString() : '-', 28, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.longe_cilindrico_olho_esquerdo ? this.novoPedido?.Receita?.longe_cilindrico_olho_esquerdo.toString() : '-', 35, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.longe_eixo_olho_esquerdo ? this.novoPedido?.Receita?.longe_eixo_olho_esquerdo.toString() : '-', 42, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.longe_dnp_olho_esquerdo ? this.novoPedido?.Receita?.longe_dnp_olho_esquerdo.toString() : '-', 49, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.adicao_olho_esquerdo ? this.novoPedido?.Receita?.adicao_olho_esquerdo.toString() : '-', 56, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_esferico_olho_esquerdo ? this.novoPedido?.Receita?.perto_esferico_olho_esquerdo.toString() : '-', 64, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_cilindrico_olho_esquerdo ? this.novoPedido?.Receita?.perto_cilindrico_olho_esquerdo.toString() : '-', 71, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_eixo_olho_esquerdo ? this.novoPedido?.Receita?.perto_eixo_olho_esquerdo.toString() : '-', 78, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_dnp_olho_esquerdo ? this.novoPedido?.Receita?.perto_dnp_olho_esquerdo.toString() : '-', 84, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.altura_pupila_olho_esquerdo ? this.novoPedido?.Receita?.altura_pupila_olho_esquerdo.toString() : '-', 122.5, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_valor_horizontal_oe ? this.novoPedido?.Receita?.prisma_valor_horizontal_oe.toString() : '-', 140, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_base_horizontal_oe ? this.novoPedido?.Receita?.prisma_base_horizontal_oe.toString() : '-', 150, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_valor_vertical_oe ? this.novoPedido?.Receita?.prisma_valor_vertical_oe.toString() : '-', 170, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_base_vertical_oe ? this.novoPedido?.Receita?.prisma_base_vertical_oe.toString() : '-', 180, camInt1linha3);
      // 2° quadro interno
      doc.roundedRect(15, 117, 180, 18, 2, 2); // retangulo interno
      doc.setFontSize(8); 
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(20, 115, 27, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(25,9,175);
      doc.text('Dados da armação', 21, camInt2titulo);
      doc.setTextColor(0,0,0);
      doc.text('Ponte', 22, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.ponte ? this.novoPedido?.Receita?.ponte.toString() : '-', 24, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Aro', 42, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.aro ? this.novoPedido?.Receita?.aro.toString() : '-', 43, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Alt. Vertical', 59, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.mov_alt_vertical ? this.novoPedido?.Receita?.mov_alt_vertical.toString() : '-', 65, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Diag.Maior', 88, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.diagonal_maior ? this.novoPedido?.Receita?.diagonal_maior.toString() : '-', 94, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Diâm. Apurado', 120, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.diametro_apurado ? this.novoPedido?.Receita?.diametro_apurado.toString() : '-', 127, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Tipo de montagem', 158, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(this.novoPedido?.Receita?.tipo_montagem ? this.tipoMontagem(this.novoPedido?.Receita?.tipo_montagem) : '-', 159, camInt2linha2);

      doc.setFont('Helvetica','','bold');
      doc.setFontSize(8);
      doc.text('Observações', 10, 148);
      // doc.text('Observações', 110, 148);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido.Receita?.observacao ? this.novoPedido.Receita?.observacao : '-', 10, 155, {maxWidth:90});
      // doc.text(item.Receita?.observacao ? item.Receita?.observacao : '-', 110, 155, {maxWidth:90});

      doc.setFont('Helvetica','','bold');
      // doc.text('Esp', 10, tituloSpec);
      doc.text('Olho', 10, tituloSpec);
      doc.text('Item', 20, tituloSpec);
      doc.text('UN', 155, tituloSpec);
      doc.text('Qtde', 170, tituloSpec);
      doc.text('Subtotal', 185, tituloSpec);
      doc.line(10,177,200,177); // linha
  
      let qttd = 0;
      for (let i = 0; i < this.novoPedido?.Carrinho.length; i++) {
        let item = i * 7;
        let linha = desc1Spec + item;
        doc.setFont('Helvetica','','normal');
        // doc.text(this.novoPedido?.Carrinho[i].uso_olho ? 'L' : 'M', 10, linha);
        doc.text(this.novoPedido?.Carrinho[i].uso_olho ? this.novoPedido?.Carrinho[i].uso_olho : '-', 10, linha);
        doc.text(this.produtosAdicionados[i]?.descricao ? this.produtosAdicionados[i]?.descricao : '-', 22, linha);
        doc.text('PC', 155, linha);
        doc.text(this.novoPedido?.Carrinho[i].quantidade ? this.novoPedido?.Carrinho[i].quantidade.toFixed(2) : '-', 170, linha);
        let formattedSubValor = this.novoPedido?.Carrinho[i].subtotal_prod.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        doc.text(`R$ ${formattedSubValor}`, 185, linha); 
        
        doc.line(10,184,200,184); // linha
        doc.line(10,191,200,191); // linha
        qttd += this.novoPedido?.Carrinho[i].quantidade;    
  
      }
      let totalLinha = (this.novoPedido?.Carrinho.length * 10) + 179;
      // doc.line(10,198,200,198); // linha
      doc.setFont('Helvetica','','bold');
      doc.text('Totais:', 130, totalLinha);
      doc.text(qttd.toFixed(2).toString(), 170, totalLinha);
      let formattedValorT = this.valorTotal().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      doc.text(`R$ ${formattedValorT}`, 185, totalLinha);

    } 
    if(opcaoPedidoSelecionado === 'pedido_atacado') {
      doc.setFont('Helvetica','','bold');
      // doc.text('Esp', 12, tituloSpec2);
      doc.text('Olho', 12, tituloSpec2);
      doc.text('Item', 22, tituloSpec2);
      doc.text('UN', 157, tituloSpec2);
      doc.text('Qtde', 172, tituloSpec2);
      doc.text('Subtotal', 187, tituloSpec2);
      doc.line(12,77,200,77); // linha
      let qttd2 = 0;
      for (let i = 0; i < this.novoPedido?.Carrinho.length; i++) {
        let item = i * 7;
        let linha = desc1Spec2 + item;
        doc.setFont('Helvetica','','normal');
        // doc.text('L', 12, linha);
        doc.text(this.novoPedido?.Carrinho[i].uso_olho ? this.novoPedido?.Carrinho[i].uso_olho : '-', 12, linha);
        doc.text(this.produtosAdicionados[i].descricao ? this.produtosAdicionados[i].descricao : '-', 24, linha);
        doc.text('PC', 157, linha);
        doc.text(this.novoPedido?.Carrinho[i].quantidade ? this.novoPedido?.Carrinho[i].quantidade.toFixed(2) : '-', 172, linha);
        let formattedSubValor = this.novoPedido?.Carrinho[i].subtotal_prod.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        doc.text(`R$ ${formattedSubValor}`, 187, linha); 
        
        doc.line(12,84,200,84); // linha
        // doc.line(12,91,200,91); // linha

        if(i >= 2 ) {
          doc.line(12,84 + 7,200,84 + 7); // linha
          doc.line(12,91 + 7,200,91 + 7); // linha
        }        
        qttd2 += this.novoPedido?.Carrinho[i].quantidade;    
  
      }
      let totalLinha = (this.novoPedido?.Carrinho.length * 7) + desc1Spec2;
      // doc.line(12,98,200,98); // linha
      doc.setFont('Helvetica','','bold');
      doc.text('Totais:', 132, totalLinha);
      doc.text(qttd2.toFixed(2).toString(), 172, totalLinha);
      let formattedValorT = this.valorTotal().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      doc.text(`R$ ${formattedValorT}`, 187, totalLinha);
    }

    let nomeArquivo = `PEDIDO-${this.pedidoCadastrado }`
    doc.save(`${nomeArquivo}.pdf`);
  }
  
  formatDate(dateString: string | undefined): string {
    if (!dateString) {
      return '';
    }
  
    const formattedDateString = dateString.replace(/_/g, '-');
    const date = new Date(formattedDateString);
  
    if (isNaN(date.getTime())) {
      return 'Data inválida';
    }
  
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
  
    return `${day}/${month}/${year}`;
  }

  logoLaboratorio() {
    let storageValue = localStorage.getItem('weblab_logo_lab'); 
    let logo = 'data:image/jpg;base64,' + storageValue;
    return logo
  }

  tipoMontagem(tipo_id: any) {
    let montagem = this.listagemTipoMontagem.filter(x => x.id.toString().includes(tipo_id.toString()));
    return montagem[0].tipo;
  }

  async loadData(id: string) {
    const data: any = await new Promise((resolve, reject) => this.service.listarPedido(id).subscribe({ next: resolve, error: reject }));
    
    this.pedidoAprovado = (data?.laboratorio_aprovado || "").trim().toUpperCase() == "S";

    this.laboratorioSelecionado = (this.lojas || []).find((l) => data?.cod_loja && l.codigo == data.cod_loja) || undefined;
    this.lojaSelecionada = (this.clientes || []).find((c) => data?.cod_cliente && c.cod_cliente == data.cod_cliente) || undefined;

    this.produtosAdicionados = (data?.Carrinho || []).map((item: any) => ({
      cod_produto: item.cod_produto,
      descricao: item.produto_descricao,
      quantidadeAdd: item.quantidade,
      vlr_venda_tratado: item.valor_un,
      desc_acresc_porcentagem: item.desc_acresc_porcentagem,
      vlr_liquido_produto: item.quantidade > 0 ? (item.subtotal_prod / item.quantidade) : 0,
      tipo_prod: item.uso_olho || ""
    }));

    const olhoDireito = this.produtosAdicionados.find(p => p.tipo_prod.toString().trim().toUpperCase() == "D") || undefined;
    const olhoEsquerdo = this.produtosAdicionados.find(p => p.tipo_prod.toString().trim().toUpperCase() == "E") || undefined;

    const formatOlhoPrismaHorizontalBase = (valor: any) => {
      if (typeof valor == "string") {
        if (/Nasal/i.test(valor.trim())) {
          return {
            id: 1,
            nome: "Nasal"
          };
        }
        else if (/Temporal/i.test(valor.trim())) {
          return {
            id: 2,
            nome: "Temporal"
          };
        }
      }

      return null;
    };

    const formatOlhoPrismaVerticalBase = (valor: any) => {
      if (typeof valor == "string") {
        if (/Inferior/i.test(valor.trim())) {
          return {
            id: 3,
            nome: "Inferior"
          };
        }
        else if (/Superior/i.test(valor.trim())) {
          return {
            id: 4,
            nome: "Superior"
          };
        }
      }

      return null;
    };

    this.dadosForm.opcaoOlhoSelecionado = "ambos";

    if (olhoDireito && !olhoEsquerdo) {
      this.dadosForm.opcaoOlhoSelecionado = "olho_direito";
    }
    else if (!olhoDireito && olhoEsquerdo) {
      this.dadosForm.opcaoOlhoSelecionado = "olho_esquerdo";
    }

    this.dadosForm.numeroOS = data?.nro_os_loja ?? null;
    this.dadosForm.paciente = data?.Receita?.paciente ?? null;
    this.dadosForm.DtReceita = data?.Receita?.data_receita  && moment(data.Receita.data_receita).isValid() ? moment(data.Receita.data_receita).toDate() : null;
    this.dadosForm.olhoDireito = {
      olhoLente: olhoDireito,
      olhoQuantidade: olhoDireito?.quantidadeAdd ?? 1,
      olhoLongeEsferico: this.formatDecimalToStringApi(data?.Receita?.longe_esferico_olho_direito),
      olhoLongeCilindrico: this.formatDecimalToStringApi(data?.Receita?.longe_cilindrico_olho_direito),
      olhoLongeEixo: this.formatDecimalToStringApi(data?.Receita?.longe_eixo_olho_direito),
      olhoLongeDNP: this.formatDecimalToStringApi(data?.Receita?.longe_dnp_olho_direito),
      olhoAdicao: this.formatDecimalToStringApi(data?.Receita?.adicao_olho_direito),
      olhoPertoEsferico: this.formatDecimalToStringApi(data?.Receita?.perto_esferico_olho_direito),
      olhoPertoCilindrico: this.formatDecimalToStringApi(data?.Receita?.perto_cilindrico_olho_direito),
      olhoPertoEixo: this.formatDecimalToStringApi(data?.Receita?.perto_eixo_olho_direito),
      olhoPertoDNP: this.formatDecimalToStringApi(data?.Receita?.perto_dnp_olho_direito),
      olhoAlturaPupila: this.formatDecimalToStringApi(data?.Receita?.altura_pupila_olho_direito),
      olhoPrismaHorizontalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_horizontal_od),
      olhoPrismaHorizontalBase: formatOlhoPrismaHorizontalBase(data?.Receita?.prisma_base_horizontal_od),
      olhoPrismaVerticalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_vertical_od),
      olhoPrismaVerticalBase: formatOlhoPrismaVerticalBase(data?.Receita?.prisma_base_vertical_od)
    };

    this.dadosForm.olhoEsquerdo = {
      olhoLente: olhoEsquerdo,
      olhoQuantidade: olhoEsquerdo?.quantidadeAdd ?? 1,
      olhoLongeEsferico: this.formatDecimalToStringApi(data?.Receita?.longe_esferico_olho_esquerdo),
      olhoLongeCilindrico: this.formatDecimalToStringApi(data?.Receita?.longe_cilindrico_olho_esquerdo),
      olhoLongeEixo: this.formatDecimalToStringApi(data?.Receita?.longe_eixo_olho_esquerdo),
      olhoLongeDNP: this.formatDecimalToStringApi(data?.Receita?.longe_dnp_olho_esquerdo),
      olhoAdicao: this.formatDecimalToStringApi(data?.Receita?.adicao_olho_esquerdo),
      olhoPertoEsferico: this.formatDecimalToStringApi(data?.Receita?.perto_esferico_olho_esquerdo),
      olhoPertoCilindrico: this.formatDecimalToStringApi(data?.Receita?.perto_cilindrico_olho_esquerdo),
      olhoPertoEixo: this.formatDecimalToStringApi(data?.Receita?.perto_eixo_olho_esquerdo),
      olhoPertoDNP: this.formatDecimalToStringApi(data?.Receita?.perto_dnp_olho_esquerdo),
      olhoAlturaPupila: this.formatDecimalToStringApi(data?.Receita?.altura_pupila_olho_esquerdo),
      olhoPrismaHorizontalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_horizontal_oe),
      olhoPrismaHorizontalBase: formatOlhoPrismaHorizontalBase(data?.Receita?.prisma_base_horizontal_oe),
      olhoPrismaVerticalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_vertical_oe),
      olhoPrismaVerticalBase: formatOlhoPrismaVerticalBase(data?.Receita?.prisma_base_vertical_oe)
    };

    const tiposMontagem: any[] = [
      {
        id: 1,
        nome: 'Aro fechado'
      },
      {
        id: 2,
        nome: 'Meio Aro (Fio de Nylon)'
      },
      {
        id: 3,
        nome: 'Três peças (Balgriff)'
      },
      {
        id: 4,
        nome: 'Esportiva'
      }
    ];

    this.dadosForm.armacao = {
      tipoMontagem: tiposMontagem.find(t => t.id == data?.Receita?.tipo_montagem) || null,
      armacaoPonte: this.formatDecimalToStringApi(data?.Receita?.ponte),
      armacaoAro: this.formatDecimalToStringApi(data?.Receita?.aro),
      armacaoAltVertical: this.formatDecimalToStringApi(data?.Receita?.mov_alt_vertical),
      armacaoDiagMaior: this.formatDecimalToStringApi(data?.Receita?.diagonal_maior),
      armacaoDiamApurado: data?.Receita?.diametro_apurado ?? null,
      armacaoDistPupilar: this.formatDecimalToStringApi(data?.Receita?.distancia_pupilar)
    };

    this.dadosForm.observacao = data?.Receita?.observacao ?? null;
  }
}